import { render, staticRenderFns } from "./MessageCode.vue?vue&type=template&id=ece930c6"
import script from "./MessageCode.vue?vue&type=script&lang=js"
export * from "./MessageCode.vue?vue&type=script&lang=js"
import style0 from "./MessageCode.vue?vue&type=style&index=0&id=ece930c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports